import { NavItemType, GalaxySidebarSwitchTabIndex, MarsSidebarSwitchTabIndex } from '@/types/nav';

export type TabItems = Array<{
	tabIndex: GalaxySidebarSwitchTabIndex | MarsSidebarSwitchTabIndex;
	tabType: NavItemType;
	title: string;
	href: string;
}>;
export type TabItem = TabItems[0];

export const galaxyTabItems: TabItems = [
	{
		tabIndex: GalaxySidebarSwitchTabIndex.Live,
		tabType: NavItemType.Live,
		title: 'lbl_live',
		href: '/live'
	},
	{
		tabIndex: GalaxySidebarSwitchTabIndex.Sports,
		tabType: NavItemType.Sports,
		title: 'lbl_SportsParty',
		href: '/sports'
	}
];

export const marsTabItems: TabItems = [
	{
		tabIndex: MarsSidebarSwitchTabIndex.Sports,
		tabType: NavItemType.Live,
		title: 'lbl_SportsParty',
		href: '/sports'
	},
	{
		tabIndex: MarsSidebarSwitchTabIndex.Parlay,
		tabType: NavItemType.Parlay,
		title: 'lbl_mixparlay',
		href: '/sports'
	}
];